let baseUrl

export const BASE_URL = baseUrl
export const BASE_API_URL = `${process.env.REACT_APP_API_URL}/`
